import React, { useEffect, useState } from "react";

import CrossIcon from "@src/assets/icons/cross.svg";
import TrashIcon from "@src/assets/icons/trash.svg";
import { Modal } from "antd";
import { useBlocker } from "react-router-dom";
import "./unsaved_changes_modal.less";
import { RootState, useAppSelector } from "@src/setupStore";
import { BlockerState } from "@src/types";

const UnsavedChangesModal: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>();

  const {
    sharedActions: { isTableDataChanged },
  } = useAppSelector((state: RootState) => state.resourcePlanTableActionsSlice);

  const blocker = useBlocker(() => isTableDataChanged);

  useEffect(() => {
    if (blocker.state === BlockerState.BLOCKED) {
      setShowModal(true);
    } else setShowModal(false);
  }, [blocker.state]);

  return (
    <Modal
      title="Unsaved/Unsent Changes"
      centered
      closable={false}
      open={showModal}
      okButtonProps={{ type: "primary", danger: true, size: "large" }}
      okText={
        <div className="unsaved-changes-modal__button">
          <TrashIcon />
          <span className={"pl-1"}>Proceed without saving</span>
        </div>
      }
      onOk={() => blocker.proceed()}
      cancelButtonProps={{ size: "large" }}
      cancelText={
        <div className="unsaved-changes-modal__button">
          <CrossIcon className={"unsaved-changes-modal__button-cancel"} />
          <span>Close</span>
        </div>
      }
      onCancel={() => blocker.reset()}
    >
      <p>
        If you leave now the changed request(s) won’t be saved and were not sent
        to the teamlead.{" "}
      </p>
      <p className="unsaved-changes-modal__paragraph-info">
        If you want to send the changed requests, mark them with the checkbox
        and use the “Action” button to send the selected request(s)
      </p>
    </Modal>
  );
};

export default UnsavedChangesModal;
